<template>
  <form id="frm_action">
      <div class="p-formgrid">
          <div class="">
              <div class="" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
                  <label class="txt-right required">Công ty</label>
                  <DropdownScrollable cusClass="text-box m-0" :loading="loading" width="100%" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'"/>
                  <input class="input_tmp_validator" id="company" />
              </div>
              <div class="mt-3">
                  <label class="txt-right required">Tên nhà máy/ trang trại</label>
                  <InputText
                  v-model="name"
                  type="text"
                  class="text-box input-text-box"
                  maxLength="255"
                  placeholder="Nhập (tối đa 255 ký tự)"
                  />
                  <input class="input_tmp_validator" id="name" />
              </div>
              <div class="mt-3">
                  <label class="txt-right required">Phân loại cơ sở</label>
                  <div class="type-options">
                      <div class="type-option">
                          <RadioButton inputId="factory-type" name="factory_type" value="factory" v-model="type" />
                          <label class="type-option-label" for="factory-type">Nhà máy</label>
                      </div>
                      <div class="type-option">
                          <RadioButton inputId="farm-type" name="factory_type" value="farm" v-model="type" />
                          <label class="type-option-label" for="farm-type">Trang trại</label>
                      </div>
                  </div>
              </div>
              <div class="mt-3">
                  <label class="txt-right required">{{ managerLabel }}</label>
                  <DropdownScrollable
                  placeholder="Chọn"
                  :showClear="false"
                  cusClass="text-box m-0"
                  width="100%"
                  defaultLabel="fullname"
                  :multiple="false"
                  :limit="factory_users_obj.limit"
                  :loading="factory_users_obj.loading"
                  v-model="factory_users_sel"
                  :options="factory_users_obj.items"
                  :total="factory_users_obj.total"
                  @keyup="emitEventFactoryUsers"
                  @scroll="emitEventFactoryUsers"
                  @offset="changeOffsetFactoryUsers"
                  />
                  <input class="input_tmp_validator" id="factory_user" />
              </div>
              <div class="mt-2">
                <label v-for="(item, index) in factory_users" :key="index" class="cus-tags">
                  <span class="cs-tag">
                    {{item.fullname}}
                  </span>
                  <i class="fas fa-times cs-icon" v-on:click="removeFactoryUsers(index)"></i>
                </label>
              </div>
              <div class="mt-3">
                  <label class="txt-right">{{addressLabel}}</label>
                  <InputText
                  v-model="address"
                  type="text"
                  class="text-box input-text-box"
                  maxLength="500"
                  placeholder="Nhập (tối đa 500 ký tự)"
                  />
                  <input class="input_tmp_validator" id="address" />
              </div>
              <div class="mt-3">
                  <label class="txt-right">Khu vực</label>
                  <DropdownScrollable
                  placeholder="Chọn"
                  :showClear="false"
                  cusClass="text-box m-0"
                  width="100%"
                  :multiple="false"
                  :limit="zone_obj.limit"
                  :loading="zone_obj.loading"
                  v-model="zone"
                  :options="zone_obj.items"
                  :total="zone_obj.total"
                  @keyup="emitEventZone"
                  @scroll="emitEventZone"
                  @offset="changeOffsetZone"
                  />
                  <input class="input_tmp_validator" id="zone" />
              </div>
              <div class="mt-3">
                  <Checkbox v-model="active" :binary="true" />Hiển thị
              </div>
          </div>
          <Toolbar class="fixed-bottom-toolbar">
              <template slot="right">
                  <Button
                  :label="$constants.TEXT_BUTTON.BACK"
                  @click="backToList()"
                  class="p-button-warning return-style-button" />
                  <Button
                  v-if="mode == 'edit'"
                  :label="$constants.TEXT_BUTTON.EDIT"
                  @click="saveData()"
                  class="p-button-success main-style-button" />
                  <Button
                  v-else
                  :label="$constants.TEXT_BUTTON.ADD"
                  @click="saveData()"
                  class="p-button-success main-style-button" />
              </template>
          </Toolbar>
      </div>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";
export default {
  components:{
      DropdownScrollable
  },
  props: {
      mode: String,
      model: Object,
      users: Array,
  },
  data() {
      return {
          filters: {},
          name: "",
          type: "factory",
          active: true,
          address : "",
          company: {},
          items: [],
          total: 0,
          loading: false,
          offset: 0,
          zone: null,
          zone_obj: {
              offset: 0,
              filters: {},
              limit: 20,
              items: [],
              total: 0,
              loading: false
          },
          factory_users : [],
          factory_users_obj : {
              offset: 0,
              filters: {},
              limit: 20,
              items: [],
              total: 0,
              loading: false
          },
          company_id : null,
          factory_users_sel : null,
      };
  },
  async mounted() {
      await this.getListCompany();
      if (this.model !== undefined && Object.keys(this.model).length > 0) {
          this.company = this.model.company;
          this.active = this.model.active;
          this.name = this.model.name;
          this.type = this.model.type || "factory";
          this.address = this.model.address;
          this.zone = this.model.zone || (this.model.zone_id ? { id: this.model.zone_id, name: this.model.zone_name } : null);
          await this.getListZone();
          //await this.getListFactoryUsers();
          this.factory_users = this.model.factory_users;
          this.factory_users = this.model.factory_users.map(user => {
              return { id: user.uid, fullname: user.fullname };
          });
      }else{
        if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
          this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
          this.company = {id: this.company_id};
          await this.getListZone();
        }
      }
  },
  watch: {
      async "company_id"() {
          if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
              this.company = {id: this.company_id};
              await this.getListZone();
              await this.getListFactoryUsers();
          }
      },
      async "$store.getters.company_id"() {
          if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
              this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
              this.company = {id: this.company_id};
              await this.getListZone();
              await this.getListFactoryUsers();
          }
      },
      async "company"() {
        this.factory_users_sel= null;
          if (this.mode == "add") {
              this.factory_users = null;
              this.zone = null;
              await this.clearChangeCompany();
          }
          await this.getListZone();
          await this.getListFactoryUsers();
          if (this.mode == "edit" && this.loadKey == 0) {
              this.loadKey++;
          }
      },
      async "factory_users_sel"() {
        if(this.$commonFuction.isEmptyObject(this.factory_users_sel)){
            return;
        }else{
            var check_exist = false;
            for (let i = 0; i < this.factory_users.length; i++) {
                if(this.factory_users[i].id == this.factory_users_sel.id){
                    check_exist = true;
                    break;
                }
            }
            if(check_exist == false){
                this.factory_users.push(this.factory_users_sel);
            }
            this.factory_users_sel = null;
        }
      },
  },
  computed: {
      managerLabel() {
          return this.type === "farm" ? "Trưởng trại" : "Quản lý nhà máy";
      },
      addressLabel(){
        return this.type === "farm" ? "Địa chỉ trang trại" : "Địa chỉ nhà máy";
      }
  },
  methods: {
      backToList() {
          this.$emit("back");
      },
      async emitEvent(keyword) {
          this.$delete(this.filters, 'name');
          if (keyword) {
              this.filters.name = keyword;
          }
          await this.getListCompany();
      },
      async changeOffset(value) {
          this.offset = value;
      },
      async getListCompany() {
          var token = this.$store.getters.token ? this.$store.getters.token : null;
          if(token){
              const headers = {
                  "Authorization": "Bearer "+token,
              };
              this.loading = true;
              await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset, company_id: this.company.id}, {headers}).then((res) => {
                  if (this.offset > 0) {
                      this.items.push(...res.data.data.company);
                  } else {
                      this.items = res.data.data.company;
                  }
                  this.total = res.data.data.total;
                  this.loading = false;
              }).catch((err) => {
                  console.log(err);
                  this.loading = false;
              });
          }
      },
      emitEventZone(keyword) {
          this.$delete(this.zone_obj.filters, 'name');
          if (keyword) {
              this.zone_obj.filters.name = keyword;
          }
          this.getListZone();
      },
      changeOffsetZone(value) {
          this.zone_obj.offset = value;
      },
      async getListZone() {
          if (this.$commonFuction.isEmptyObject(this.company)) {
              this.zone_obj = {
                  offset: 0,
                  filters: {},
                  limit: 20,
                  items: [],
                  total: 0,
                  loading: false
              };
              return;
          }
          var token = this.$store.getters.token ? this.$store.getters.token : null;
          if (token) {
              const headers = {
                  "Authorization": "Bearer "+token,
              };
              this.zone_obj.loading = true;
              await ApiRepository.post("/_api/zone/options", {filters: this.zone_obj.filters, limit: this.zone_obj.limit, offset: this.zone_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
                  var tmp = res.data.data?.zone ?? [];
                  if (this.zone_obj.offset > 0) {
                      this.zone_obj.items.push(...tmp);
                  } else {
                      this.zone_obj.items = tmp;
                  }
                  this.zone_obj.total = res.data.data.count ?? res.data.data.total ?? 0;
                  this.zone_obj.loading = false;
              }).catch((err) => {
                  console.log(err);
                  this.zone_obj.loading = false;
              });
          }
      },
      async validateData() {
          this.validationErrors = {};
          if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
              let company_add = document.getElementById("company");
              if (
                  this.$commonFuction.isEmptyObject(this.company) ||
                  this.$commonFuction.isEmpty(this.company)
              ) {
                  company_add.setCustomValidity("Vui lòng chọn công ty!");
              } else {
                  company_add.setCustomValidity("");
              }
          }
          let name_add = document.getElementById("name");
          if (this.name == undefined || this.name == null || this.name == "") {
              name_add.setCustomValidity("Vui lòng nhập tên nhà máy/ trang trại!");
          } else if (this.name.length > 255) {
              name_add.setCustomValidity("Tên nhà máy/ trang trại không được quá 255 ký tự!");
          } else {
              name_add.setCustomValidity("");
          }
          let factory_user_add = document.getElementById("factory_user");
          if (this.$commonFuction.isEmptyObject(this.factory_users) || this.factory_users.length == 0) {
              factory_user_add.setCustomValidity(`Vui lòng chọn người dùng ${this.managerLabel.toLowerCase()}!`);
          } else {
              factory_user_add.setCustomValidity("");
          }
          var inpObj = document.getElementById("frm_action");
          if (!inpObj.checkValidity()) {
              inpObj.reportValidity();
              return true;
          }
      },
      async saveData() {
          this.$commonFuction.is_loading(true);
          if (await this.validateData()) {
              this.$commonFuction.is_loading(false);
              return;
          }
          if (Object.entries(this.validationErrors).length !== 0) {
              this.$commonFuction.is_loading(false);
          }
          var params = {
              name: this.name,
              type: this.type,
              address: this.address,
              active: this.active,
              company: this.company,
              zone: this.zone,
              factory_users : this.factory_users
          };
          console.log("saveData", params);
          this.$emit("save", params);
      },
      emitEventFactoryUsers(keyword) {
        this.$delete(this.factory_users_obj.filters, 'fullname');
        if (keyword) {
            this.factory_users_obj.filters.fullname = keyword;
        }
          this.getListFactoryUsers();
      },
      changeOffsetFactoryUsers(value) {
          this.factory_users_obj.offset = value;
      },
      async getListFactoryUsers() {
          if (this.$commonFuction.isEmptyObject(this.company)) {
              this.factory_users_obj = {
                    offset: 0,
                    filters: {},
                    limit: 20,
                    items: [],
                    total: 0,
                    loading: false
              };
              return;
          }
          var token = this.$store.getters.token ? this.$store.getters.token : null;
          if(token){
              const headers = {
                  "Authorization": "Bearer "+token,
              };
              this.factory_users_obj.loading = true;
              await ApiRepository.post("/_api/users/options", {filters: this.factory_users_obj.filters, limit: this.factory_users_obj.limit, offset: this.factory_users_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
                  var tmp = res.data.data?.list;
                  if (this.factory_users_obj.offset > 0 ) {
                      this.factory_users_obj.items.push(...tmp);
                  } else{
                      this.factory_users_obj.items = tmp;
                  }
                  this.factory_users_obj.total = res.data.data.count;
                  this.factory_users_obj.loading = false;
              }).catch((err) => {
                  console.log(err);
                  this.factory_users_obj.loading = false;
              });
          }
      },
      async clearChangeCompany(){
          this.zone_obj ={
              offset: 0,
              filters: {},
              limit: 20,
              items: [],
              total: 0,
              loading: false
          };
          this.factory_users_obj ={
              offset: 0,
              filters: {},
              limit: 20,
              items: [],
              total: 0,
              loading: false
          };
          this.factory_users = [];
      },
      async removeFactoryUsers(index){
          this.factory_users.splice(index, 1);
      }
  },
};
</script>

<style lang="scss">
label {
font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
.type-options {
  display: flex;
  gap: 16px;
  align-items: center;
}
.type-option {
  display: flex;
  align-items: center;
  gap: 8px;
}
.type-option-label {
  margin-bottom: 0;
  font-weight: normal;
  cursor: pointer;
}
.cus-tags{
  border-radius: 10px;
  padding: 8px;
  margin-right: 8px;
  background-color:#F2F3F7;
}
.cs-tag {
  padding: 10px 12px 10px 0px;
  font-weight: normal;
}
.cs-icon {
  color : #666666;
  padding-right: 4px;
  cursor: pointer;
}
</style>
